<template>
    <v-container>
        <v-data-table
            :headers="headers"
            :items="accounts"
            :sort-by="['description']"
            class="elevation-5"
            :items-per-page="20" 
            :footer-props="{
                'items-per-page-options' : [20, 40, -1]
            }"
        >
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>
                        Cuentas del servicio T&D WebStorage
                    </v-toolbar-title>
                    <v-spacer></v-spacer>

                    <!-- DIALOG ------------------------------------------------------------------------- -->

                    <v-dialog v-model="dialog">
                        <template v-slot:activator="{ on }" >
                            <v-btn color="primary" dark class="mb-2" v-on="on">
                                A&ntilde;adir Nueva
                            </v-btn>
                        </template>

                        <v-card>
                            <v-card-title>
                                <span clas="headline">{{ formTitle }}</span>
                            </v-card-title>

                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="6" xs="12">
                                            <v-text-field v-model="editedItem.location" label="Localidad" ></v-text-field>
                                        </v-col>
                                        <v-col cols="6" xs="12">
                                            <v-text-field v-model="editedItem.description" label="Canal" ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6" xs="12">
                                            <v-text-field v-model="editedItem.loginId" label="Login ID" ></v-text-field>
                                        </v-col>
                                        <v-col cols="6" xs="12">
                                            <v-text-field v-model="editedItem.loginPassword" label="Password" ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" xs="12">
                                            <v-text-field v-model="editedItem.apiKey" label="API Key" ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <!-- <v-row>
                                         <v-col cols="12" sm="6"  md="4">
                                         <v-checkbox
                                         dense
                                         v-model="editedItem.users"
                                         v-for="(user, index) in allAccountUsers"
                                         :key="index"
                                         :label="user"
                                         :value="user"
                                         >
                                         </v-checkbox>
                                         </v-col>
                                         <v-col cols="12" sm="6"  md="4">
                                         <v-text-field v-model="newUser" label="Usuario Nuevo" ></v-text-field>
                                         </v-col>
                                         </v-row> -->
                                </v-container>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close" >Cancelar</v-btn>
                                <v-btn color="blue darken-1" text @click="save" >Guardar</v-btn>
                            </v-card-actions>

                        </v-card>

                    </v-dialog>

                    <!-- END DIALOG --------------------------------------------------------------------- -->

                </v-toolbar>
            </template>

            <template v-slot:item.userCount="{ item }" >
                {{ item.users.length }}
            </template>

            <template v-slot:item.enabled="{ item }">
                <v-simple-checkbox v-model="item.enabled" disabled>
                </v-simple-checkbox>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-icon class="mr-2" @click="checkItem( item )">
                    mdi-eye-check
                </v-icon>
                <v-icon class="mr-2" @click="editItem( item )">
                    mdi-pencil
                </v-icon>
                <v-icon class="mr-2" @click="deleteItem( item )">
                    mdi-delete
                </v-icon>
            </template>
        </v-data-table>

        <v-snackbar
            v-model="alert.enabled"
            :color="alert.type"
            :timeout="5000"
        >
            {{ alert.message }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    dark
                    text
                    v-bind="attrs"
                    @click="alert.enabled = false"
                >
                    Cerrar
                </v-btn>
            </template>
        </v-snackbar>

    </v-container>
</template>

<script>
import { API } from 'aws-amplify';
import { createTndAccount, updateTndAccount, deleteTndAccount } from '@/graphql/mutations';
import { listTndAccounts } from '@/graphql/queries';
import { onCreateTndAccount, onUpdateTndAccount, onDeleteTndAccount } from '@/graphql/subscriptions';
import { deduplicate, pingAccount } from '@/tools';
import { compareAccounts } from '@/view-accounts-tool';

export default {
    name: 'TndAccountAdministration',

    async created() {
        this.getAccounts();
        this.subscribe();
    },

    data: () => ({

        accounts : [],

        allAccountUsers : [],

        // Alerts

        alert: {
            enabled : false,
            type : 'success',
            meessage : '',
            timeout : false,
        },

        // Dialog to edit accounts

        dialog : false,
        editedIndex : -1,
        editedItem : {
            enabled : true,
            location : '',
            description : '',
            loginId : '',
            loginPassword : '',
            apiKey : '',
            users : [],
        },
        defaultItem : {
            enabled : true,
            location : '',
            description : '',
            loginId : '',
            loginPassword : '',
            apiKey : '',
            users: [],
        },
        newUser : '',

        // Table
        headers : [
            { text : 'Localidad', value : 'location' },
            { text : 'Canal', value : 'description' },
            { text : 'Login', value : 'loginId' },
            // { text : 'Password', value : 'loginPassword' },
            // { text : 'T&D API Key', value : 'apiKey' },
            // { text : 'Activa', value : 'enabled' },
            // { text : 'Usuarios', value: 'userCount' },
            { text : '', value: 'actions', sortable : false },
        ],
    }),

    computed : {
        formTitle() {
            return this.editedIndex === -1 ? 'Añadir Cuenta' : 'Modificar Cuenta';
        }
    },

    methods : {

        ////////////////////////////////////////////////////////////////////////////////
        // Edit Dialog

        updateAllAccountUsers( users ) {
            this.allAccountUsers = deduplicate( this.allAccountUsers.concat( users ) ).sort();
        },

        editItem( account ) {
            this.editedIndex = this.accounts.indexOf( account );
            this.editedItem = Object.assign( {}, account );

            this.dialog = true;
        },

        deleteItem( account ) {
            this.deleteAccount( account );
        },

        checkItem( account ) {
            this.checkAccount( account );
        },

        close() {
            this.dialog = false;
            this.$nextTick( () => {
                this.editedItem = Object.assign( {}, this.defaultItem );
                this.editedIndex = -1;
                this.newUser = '';
            } );
        },

        async save() {
            if ( this.editedIndex > -1 ) {
                this.updateAccount( this.accounts[ this.editedIndex ], this.editedItem, this.newUser );
            }
            else {
                this.addAccount( this.editedItem, this.newUser );
            }
            this.close();
        },

        ////////////////////////////////////////////////////////////////////////////////
        // Alerts

        showAlert( success, message ) {
            console.log( 'alert', success, message );

            if ( this.alert.timeout ) {
                clearTimeout( this.alert.timeout );
            }

            this.alert = {
                enabled : true,
                type    : success ? 'success' : 'error',
                message : message,
                timeout : setTimeout( this.clearAlert, 2000 ),
            };
        },

        clearAlert() {
            this.alert = {
                enabled : false,
                type    : 'success',
                message : '',
                timeout : false,
            };
        },


        ////////////////////////////////////////////////////////////////////////////////
        // Back end

        async getAccounts() {
            const accounts = await API.graphql( { query: listTndAccounts, variables : { limit : 1000 } } );

            this.accounts = accounts.data.listTndAccounts.items.sort( compareAccounts );
            this.updateAllAccountUsers( this.accounts.flatMap( account => account.users ) );
        },

        updateAccount( account, newValues, newUser ) {
            const updatedValues = Object.assign( { id : account.id }, newValues );
            if ( newUser.trim() )
                updatedValues.users.push( newUser.trim() );

            updatedValues.users = deduplicate( updatedValues.users );

            const params = {
                query : updateTndAccount,
                variables : { input : updatedValues },
            };

            API.graphql( params )
               .catch( error => console.log( 'Error saving account', error ) );
        },

        async addAccount( account, newUser ) {
            let { enabled,  location, description, loginId, loginPassword, apiKey, users } = account;
            if ( ! enabled || ! location || ! description || ! loginId || ! loginPassword || ! apiKey || ! users )
                return;

            if ( newUser.trim() )
                users.push( newUser.trim() );

            users = deduplicate( users );

            const accountValues = { enabled, location, description, loginId, loginPassword, apiKey, users };

            const params = {
                query : createTndAccount,
                variables : { input : accountValues }
            };

            await API.graphql( params )
                     .then( () => console.log( `Added account ${description}` ) )
                     .catch( error => console.log( `Error adding account ${description}`, error ) );
        },

        async deleteAccount( account ) {
            await API.graphql( {
                query : deleteTndAccount,
                variables : { input : { id : account.id } } 
            } );
        },

        checkAccount( account ) {
            console.log( `Checking account ${account.loginId}` );

            pingAccount( {}, account )
                .then( devices => {
                    // console.log( 'tndaccountpingapi response', devices );

                    const count = devices.length;
                    this.showAlert( true, `Conexión exitosa, la cuenta ${account.loginId} tiene ${count} sensores.` );
                } )
                .catch( () => {
                    this.showAlert( false, `Fallo la conexión a la cuenta ${account.loginId}. Verifique la configuración.` );
                } );
        },

        subscribe() {
            API.graphql( { query : onCreateTndAccount } ).subscribe( {
                next : ( eventData ) => {
                    const account = eventData.value.data.onCreateTndAccount;
                    // console.log( 'onCreateTndAccount', account );
                    this.accounts = [ ...this.accounts, account ];
                    this.updateAllAccountUsers( account.users );
                },
            } );
            API.graphql( { query : onUpdateTndAccount } ).subscribe( {
                next : ( eventData ) => {
                    const updatedAccount = eventData.value.data.onUpdateTndAccount;

                    const accounts = this.accounts.filter( account => account.id !== updatedAccount.id );

                    this.accounts = [ ...accounts, updatedAccount ];
                    this.updateAllAccountUsers( updatedAccount.users );
                },
            } );
            API.graphql( { query : onDeleteTndAccount } ).subscribe( {
                next : ( eventData ) => {
                    const deletedAccount = eventData.value.data.onDeleteTndAccount;

                    const accounts = this.accounts.filter( account => account.id !== deletedAccount.id );
                    this.accounts = accounts;
                },
            } );
        },
    },
}
</script>
